import styled from 'styled-components';

export const StopwatchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const TimerText = styled.span`
  font-size: 36px;
  letter-spacing: 1px;
`;
